import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st7{fill:none;stroke:{{strokeColor}};stroke-width:1.5;stroke-miterlimit:10;}
    .st8{fill:none;stroke:{{strokeColor}};stroke-width:3;stroke-miterlimit:10;}
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
  </style>
  <g>
    <line class="st7" x1="1.9" y1="25" x2="28.1" y2="25"/>
    <line class="st8" x1="5.3" y1="22.8" x2="5.3" y2="18.1"/>
    <line class="st8" x1="10.2" y1="22.8" x2="10.2" y2="15.1"/>
    <line class="st8" x1="15.1" y1="22.8" x2="15.1" y2="18.1"/>
    <line class="st8" x1="20" y1="22.8" x2="20" y2="13.1"/>
    <line class="st8" x1="25" y1="22.8" x2="25" y2="10.1"/>
    <polyline class="st9" points="4.7,15.7 9.6,9.7 14.9,15.1 25.2,5"/>
  </g>
</svg>

`

export const chartAndGauge: ComponentGroup = {
  name: 'chartAndGauge',
  description: 'a group of various charts and gauges',
  icon,
  templates: []
}
